import React, { useEffect } from "react";
import "./dailyProgram.scss";

import SearchIcon from "@mui/icons-material/Search";

import { isEmpty } from "../../../../utils/validation";
import { t } from "i18next";
import { Button, Stack } from "react-bootstrap";
import { useScreenSize } from "../../../../ScreenSizeContext";
import { useNavigate } from "react-router-dom";

const DailyProgram = ({ data }) => {
  const navigate = useNavigate();
  const isPC = useScreenSize();

  const date = new Date();
  const mesi = t("calendar.months", { returnObjects: true });
  return !isPC ? (
    <>
      {/*MOBILE */}
      <div className="daily-program-container">
        <div className="title">
          {t("home.title", { name: localStorage.getItem("name") })}
        </div>
        <div className="subtitle">{t("home.subtitle")}</div>
        <div className="daily-program-box mt-2">
          <div className="left-column" onClick={() => navigate("/calendar")}>
            <div className="date-info">
              <div className="month">{mesi[date.getMonth()].toUpperCase()}</div>
              <div className="number-day">{date.getDate()}</div>
            </div>
            <div className="icon-calendar">
              <span className="lnr lnr-calendar-full icon-bottom-bar"></span>
            </div>
          </div>
          <div className="right-column">
            {!isEmpty(data.shift)
              ? data.shift.map((item, index) => (
                  <ActivityBox
                    key={index}
                    item={item}
                    backgroundColor="rgba(149, 196, 88, 0.34)"
                    variantButton="secondary"
                    link={`/calendar`}
                  />
                ))
              : null}
            {!isEmpty(data.manage_shift)
              ? data.manage_shift.map((item, index) => (
                  <ActivityBox
                    key={index}
                    item={item}
                    backgroundColor="rgba(255, 182, 29, 0.43)"
                    variantButton="warning"
                    link={`/calendar?admin=${item.id_association}`}
                  />
                ))
              : null}
            {/*Nessuna attivita da gestire o a cui sono iscritto */}
            {isEmpty(data.shift) && isEmpty(data.manage_shift) ? (
              <div className="no-item">
                <div className="content-text">{t("home.no_content")}</div>
                <Button
                  style={{ borderRadius: 20 }}
                  variant="success"
                  size="sm"
                  onClick={() => navigate("/explore")}
                >
                  <Stack
                    direction="horizontal"
                    className="d-flex justify-content-center align-items-center"
                    gap={1}
                  >
                    <SearchIcon />
                    {t("home.add_activity")}
                  </Stack>
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      {/*PC*/}
      <div className="daily-program-container container-on-right">
        <Stack
          direction="horizontal"
          className="d-flex justify-content-between w-100"
          onClick={() => navigate("/calendar")}
        >
          <div className="date-info">
            <div className="month">{mesi[date.getMonth()].toUpperCase()}</div>
            <div className="number-day">{date.getDate()}</div>
          </div>
          <div className="icon-calendar">
            <Button variant="light" size="sm" className="rounded-5">
              <Stack direction="horizontal" gap={2}>
                <span className="lnr lnr-calendar-full icon-bottom-bar"></span>
                <span>{t("home.activity_in_calendar")}</span>
              </Stack>
            </Button>
          </div>
        </Stack>
        <hr />
        <Stack
          direction="vertical"
          gap={3}
          className="d-flex justify-content-center"
        >
          {!isEmpty(data.shift)
            ? data.shift.map((item, index) => (
                <ActivityBox
                  key={index}
                  item={item}
                  backgroundColor="rgba(149, 196, 88, 0.34)"
                  variantButton="secondary"
                  link={"/calendar"}
                />
              ))
            : null}
          {!isEmpty(data.manage_shift)
            ? data.manage_shift.map((item, index) => (
                <ActivityBox
                  key={index}
                  item={item}
                  backgroundColor="rgba(255, 182, 29, 0.43)"
                  variantButton="warning"
                  link={`/calendar?admin=${item.id_association}`}
                />
              ))
            : null}
          {/*Nessuna attivita da gestire o a cui sono iscritto */}
          {isEmpty(data.shift) && isEmpty(data.manage_shift) ? (
            <div className="no-item">
              <div className="content-text">{t("home.no_content")}</div>
              <Button
                style={{ borderRadius: 20 }}
                variant="success"
                size="sm"
                onClick={() => navigate("/explore")}
              >
                <Stack
                  direction="horizontal"
                  className="d-flex justify-content-center align-items-center"
                  gap={1}
                >
                  <SearchIcon />
                  {t("home.add_activity")}
                </Stack>
              </Button>
            </div>
          ) : null}
        </Stack>
      </div>
    </>
  );
};

const ActivityBox = ({
  item,
  backgroundColor,
  variantButton,
  link = "/calendar",
}) => {
  const navigate = useNavigate();
  console.log(item);
  return (
    <div
      className="activity-box"
      style={backgroundColor ? { backgroundColor } : null}
    >
      <div>
        <div className="title">{item.name_event}</div>
        <div className="info">
          {item.address}, {item.start_datetime}
        </div>
      </div>
      <div className="button-details-box">
        <Button
          className="button-details"
          variant={variantButton}
          size="sm"
          onClick={() => navigate(link)}
        >
          {t("common.details")}
        </Button>
      </div>
    </div>
  );
};

export default DailyProgram;
